import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getData, putData } from '../Services/api';
import { toast } from 'react-toastify';
import Pagination from '../Services/Pagination';

const POStatus = () => {
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [perPage] = useState(10);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');

    const fetchOrders = async (pageNumber = page, searchQuery = search, statusQ = statusFilter) => {
        try {
            const res = await getData(`/proforma-orders/all?page=${pageNumber}&limit=${perPage}&search=${searchQuery}&status=${statusQ}`);
            if (res.status) {
                setOrders(res.data || []);
                setPage(res.pagination.page || 1);
                setPages(res.pagination.totalPages || 1);
                setTotal(res.pagination.total || 0);
            }
        } catch (error) {
            console.error("Error fetching POs:", error);
        }
    };

    const handleStatusChange = async (orderId, newStatus) => {
        try {
            const res = await putData(`/proforma-orders/status/${orderId}`, { status: newStatus });
            if (res.status) {
                toast.success("Status updated successfully!");
                fetchOrders(); // refresh the list
            } else {
                toast.error(res.message || "Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error(error.response?.data?.message || "Failed to update status");
        }
    };

    useEffect(() => {
        fetchOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, perPage, search, statusFilter]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            setPage(pageNumber);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/accounts-dashboard/status">Accounts</Link></li>
                                    <li className="breadcrumb-item" aria-current="page">PO Status</li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0 premium-header">Proforma Orders Status</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-sm-flex align-items-center p-4">
                                    <ul className="list-inline me-auto my-1">
                                        <li className="list-inline-item">
                                            <div className="form-search">
                                                <i className="fas fa-search text-muted" />
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder="Search Customer or PO..."
                                                    value={search}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value);
                                                        setPage(1);
                                                    }}
                                                />
                                            </div>
                                        </li>
                                        <li className="list-inline-item ms-3">
                                            <select 
                                                className="form-select" 
                                                value={statusFilter} 
                                                onChange={(e) => {
                                                    setStatusFilter(e.target.value);
                                                    setPage(1);
                                                }}
                                            >
                                                <option value="all">All Status</option>
                                                <option value="checking">Checking</option>
                                                <option value="ready_for_delivery">Ready for Delivery</option>
                                                <option value="cancelled">Cancelled</option>
                                                <option value="invoiced">Invoiced</option>
                                            </select>
                                        </li>
                                    </ul>
                                </div>

                                <div className="table-responsive px-2">
                                    <table className="table table-hover" id="pc-dt-simple">
                                        <thead>
                                            <tr>
                                                <th>PO Number</th>
                                                <th>PO Type</th>
                                                <th>Customer Name</th>
                                                <th>Date & Time</th>
                                                <th>Total Amount</th>
                                                <th className="text-center">Status</th>
                                                <th>Invoice No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders.length > 0 ? orders.map((order, index) => {
                                                return (
                                                <tr key={order.id}>
                                                    <td className="fw-bold text-dark">{order.po_number}</td>
                                                    <td><span className="text-muted">{order.po_type || '-'}</span></td>
                                                    <td className="fw-bold text-dark">{order.customer_name}</td>
                                                    <td><span className="text-muted">{order.date} <br/><small>{order.time}</small></span></td>
                                                    <td className="fw-bold">Tzs {Number(order.total_amount).toLocaleString('en-US')}</td>
                                                    <td className="text-center">
                                                        {order.status === 'invoiced' ? (
                                                            <span className="badge bg-success">INVOICED</span>
                                                        ) : (
                                                            <select 
                                                                className="form-select form-select-sm"
                                                                value={order.status}
                                                                onChange={(e) => handleStatusChange(order.id, e.target.value)}
                                                                style={{ minWidth: '140px' }}
                                                            >
                                                                <option value="checking">Checking</option>
                                                                <option value="ready_for_delivery">Ready for Delivery</option>
                                                                <option value="cancelled">Cancelled</option>
                                                            </select>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {order.invoice_number ? (
                                                            <span className="badge bg-light text-dark shadow-sm border">{order.invoice_number}</span>
                                                        ) : (
                                                            <span className="text-muted opacity-50">-</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            )}) : (
                                                <tr>
                                                    <td className='text-center py-5 text-muted' colSpan={7}>
                                                        <i className="fas fa-box-open fs-3 mb-2 opacity-50"></i><br/>
                                                        <strong>No Proforma Orders Found.</strong>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                    <div className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {Math.min(page * perPage, total)} of {total} entries
                                    </div>
                                    <Pagination page={page} pages={pages} onPageChange={handlePageChange} />
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default POStatus;
